// extracted by mini-css-extract-plugin
module.exports = {"button":"arrowbutton_button__J60XZ","icon":"arrowbutton_icon__doAqI","text":"arrowbutton_text__jh18f","iconRound":"arrowbutton_iconRound__drjIR","after":"arrowbutton_after__QQfUx"};